import {
    FETCHED_MENUS,
    FETCHED_MENU_ITEMS,
    FETCHED_MENU_CLASSES
} from './types';

export function fetchedMenus(menus) {
    return {
        type: FETCHED_MENUS,
        menus
    }
}

export function fetchedMenuItems(menuItems) {

    return {
        type: FETCHED_MENU_ITEMS,
        payload: {
            data: menuItems,
            touched: false
        }
    };
}

export function fetchedMenuClasses(menuClasses) {
    return {
        type: FETCHED_MENU_CLASSES,
        menuClasses
    }
}

export function updateMenuItemsTreeData(updatedMenuItemsTreeData) {
    return {
        type: FETCHED_MENU_ITEMS,
        payload: {
            data: updatedMenuItemsTreeData,
            touched: true
        }
    };
}


// WEBPACK FOOTER //
// ./src/containers/menus/actions.js